<template>
  <b-row v-if="$can('SetWallet', 'Users')">
    <b-col cols="12">
      <h3 class="mb-2">ویرایش کیف پول</h3>
      <b-form-group label="موجودی کیف پول کاربر" label-for="defaultCredit">
        <b-input-group append="تومان">
          <b-form-input
            dir="auto"
            style="text-align: right"
            :value="formattedWalletCredit"
            :disabled="true"
            id="defaultCredit"
            type="text"
            trim
          />
        </b-input-group>
      </b-form-group>
      <b-form-group label="مقدار تغییر" label-for="walletCredit">
        <b-input-group>
          <b-form-input
            dir="rtl"
            v-model="formattedWalletCreditInput"
            id="walletCredit"
            trim
            :disabled="isLoading"
            type="tel"
            placeholder="برای مثال 40000"
          />
          <b-input-group-append>
            <b-button
              variant="danger"
              @click="updateUserWallet(true)"
              :disabled="isLoading"
            >
              کاهش
            </b-button>
            <b-button
              variant="success"
              @click="updateUserWallet(false)"
              :disabled="isLoading"
            >
              افزایش
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label="دلیل تراکنش" label-for="walletDesc">
        <b-input-group>
          <b-form-textarea
            id="walletDesc"
            v-model="walletDescription"
            placeholder="دلیل افزایش/کاهش موجودی کیف پول"
          ></b-form-textarea>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
export default {
  emits: ["refetchUser", "refetchTransactions"],
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  watch: {
    userData: {
      immediate: true,
      handler(val) {
        if (val) {
          this.userDetails = JSON.parse(JSON.stringify(this.userData));
        }
      },
    },
  },
  data() {
    return {
      userDetails: null,
      walletCredit: null,
      isLoading: false,
      walletDescription: null,
    };
  },
  methods: {
    convertNumbers2English(number) {
      return number.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, function (c) {
        return c.charCodeAt(0) & 0xf;
      });
    },
    async updateUserWallet(isMinus = false) {
      if (this.isLoading) return;
      try {
        this.isLoading = true;
        let cleanWalletCredit = this.walletCredit.replaceAll(",", "");

        cleanWalletCredit = +this.convertNumbers2English(cleanWalletCredit);
        let _this = this;
        let setUserWallet = new SetUserWallet(_this);
        setUserWallet.setRequestParamDataObj({
          userId: _this.userDetails.userId,
          price: isMinus ? cleanWalletCredit * -1 : cleanWalletCredit,
          description: _this.walletDescription,
        });
        await setUserWallet.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "بروز شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کیف پول کاربر بروز شد.",
              },
            });
            _this.walletCredit = null;
            _this.walletDescription = null;
            _this.$emit("refetchUser");
            _this.$emit("refetchTransactions");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  computed: {
    formattedWalletCredit: {
      get: function () {
        if (this.userDetails.wallet) return this.userDetails.wallet;
        return 0;
      },
      set: function (newValue) {
        if (newValue) {
          // Remove all characters that are NOT a number or minus sign
          this.userDetails.wallet = newValue
            .toString()
            .replace(/[^\d\-]/g, "")
            .replace(/(?<=\d)(?=(\d{3})+(?!\d))/g, ",");
        } else if (!newValue || newValue === "") {
          this.userDetails.wallet = null;
        }
      },
    },
    formattedWalletCreditInput: {
      get() {
        return this.walletCredit;
      },
      set(newValue) {
        // This setter is getting number, replace all commas with empty str
        // Then start to separate numbers with ',' from beginning to prevent
        // from data corruption
        if (newValue) {
          this.walletCredit = this.convertNumbers2English(newValue)
            .toString()
            .replaceAll(",", "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // Remove all characters that are NOT number
          this.walletCredit = this.walletCredit.replace(
            /[a-zA-Z+*!@#$%^&*()_;:'"|<>/?{}\u0600-\u06EC/\-/\.]/g,
            ""
          );
        } else if (!newValue || newValue === "") {
          this.walletCredit = "";
        }
      },
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BInputGroup,
    BInputGroupAppend,
  },
};
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { SetUserWallet } from "@/libs/Api/Users";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
